import React, { useEffect, useState } from "react"
import withStyles from "react-jss"
import { shuffle } from "lodash"
import {
  getWaffleChartInitialPosition,
  getWaffleChartColors,
} from "../../utils/helper"
import categories from "../../data/categories"

const BOX_SIZE = 20, //px
  MARGIN = 3, //px
  WIDTH = 10 * (BOX_SIZE + MARGIN * 2)

const styles = {
  container: {
    width: `${WIDTH}px`,
    margin: "3rem 0",
    // zIndex: 2,
  },
  rect: {
    transition: `x 0.5s ease-out,
     y 0.5s ease-out`,
  },
}

const WaffleChartSVG = ({ classes, data }) => {
  const ARRAY_SIZE = 10
  const [matrix, setMatrix] = useState(() =>
    getWaffleChartColors(ARRAY_SIZE, categories.nonalchoholic)
  )

  const [startPos] = useState(() =>
    getWaffleChartInitialPosition(ARRAY_SIZE, BOX_SIZE, MARGIN)
  )

  const [newPos, setNewPos] = useState(startPos)

  const [pos, setPos] = useState(startPos)

  useEffect(() => {
    const assignColorAndPosition = () => {
      // Shuffle the 2d array for newPos
      const temp1 = startPos.flatMap((d) => d)
      const temp2 = shuffle(temp1)
      const shuffledPos = []
      while (temp2.length) shuffledPos.push(temp2.splice(0, 10))
      setNewPos(shuffledPos)

      // Percentage check
      // The percent property should be whole numbers
      // and should add up to 100
      let totalPercent = 0
      const countSplitup = data
        ? data.map((d) => {
            totalPercent += d.percent
            return {
              count: d.percent,
              color: d.color,
              hex: d.hex,
            }
          })
        : null
      if (totalPercent !== 100) {
        return
      }

      // Update the color
      let index = 0
      const newMatrix = matrix.map((row) => {
        return row.map((obj) => {
          if (countSplitup[index].count > 0) {
            const color = countSplitup[index].color
            const hex = countSplitup[index].hex
            countSplitup[index].count -= 1
            return {
              color,
              hex,
            }
          } else {
            if (index + 1 < countSplitup.length) {
              index += 1
              const color = countSplitup[index].color
              const hex = countSplitup[index].hex
              countSplitup[index].count -= 1
              return {
                color,
                hex,
              }
            }
          }
          //
          return obj
        })
      })
      setMatrix(newMatrix)
    }

    assignColorAndPosition()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const revertToOldPosition = () => {
    setPos(startPos)
  }

  const setNewPosition = () => {
    setPos(newPos)
  }

  return (
    <div className={classes.container}>
      <svg
        className={classes.svg}
        viewBox={`0 0 ${WIDTH} ${WIDTH}`}
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onMouseEnter={setNewPosition}
        onMouseLeave={revertToOldPosition}>
        {matrix.map((row, i) =>
          row.map((d, j) => (
            <rect
              id="rect"
              key={`${i} ${j}`}
              className={classes.rect}
              x={pos[i][j].x}
              y={pos[i][j].y}
              width={BOX_SIZE}
              height={BOX_SIZE}
              // fill={d.color}
              fill={d.hex}
            />
          ))
        )}
      </svg>
    </div>
  )
}

export default withStyles(styles)(WaffleChartSVG)
